import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  ErrorHandler,
  LOCALE_ID,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideClientHydration } from '@angular/platform-browser';
import {
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
  withNavigationErrorHandler,
  withViewTransitions,
} from '@angular/router';
import { fakeBackendInterceptor } from '@core/interceptors';
import { reloadOnFailedChunk } from '@core/reload-on-failed-chunk';
import { SentryErrorHandler } from '@core/sentry';
import { environment } from '@environments/environment';
import { APP_ROUTES } from '@root/app-routing';
import { ENVIRONMENTS } from '@shared/constants';

export const APP_CONFIG: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: environment.lang },
    // No preloading: it would download every lazy route right after the first
    // navigation, while the current page is still loading its data and images.
    provideRouter(
      APP_ROUTES,
      withViewTransitions(),
      withComponentInputBinding(),
      withNavigationErrorHandler(reloadOnFailedChunk),
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'top',
      })
    ),
    provideClientHydration(),
    provideHttpClient(
      withInterceptors(
        [ENVIRONMENTS.DEV, ENVIRONMENTS.PLAYWRIGHT].includes(environment.env)
          ? [fakeBackendInterceptor]
          : []
      )
    ),
    provideZonelessChangeDetection(),
    { provide: ErrorHandler, useClass: SentryErrorHandler },
  ],
};
